export default "__VITE_ASSET__OJv4OnAa__"